// Note:- when we use filters we need to pass the filters data to the table component
// otherwise the table will not render the data
// createTable is a function which is used to create data for table component
import React, { useEffect, useState } from "react";
import PageTitle from "./PageTitle";
import Table from "./Table/index";
import Filters from "./Filters/";
import API_KEY from "api";
import moment from "moment";
import { Skeleton, Divider, Row, Col, Typography, Space } from "antd";
import Modal from "./Modal";
export default function AllCatalogues() {
  const { Text } = Typography;
  const [tableData, setTableData] = useState([]);
  const [filters, setFilters] = useState({ sort: "date" });
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);

  const [isModalVisible, setIsModalVisible] = useState(true);
  const [modalType, setModalType] = useState(null);
  const [id, setId] = useState(null);
  const [collectionDetails, setDetails] = useState({});
  const [actionLoading, setActionLoading] = useState(false);

  const [updateFilters, setUpdate] = useState(true);
  const [selectedFilters, setSelectedFilters] = useState({
    sort: { label: "Recently Created", value: "date" },
    search: "",
    buyer: ["All Buyers"],
    status: { label: "All Catalogues", value: "All Catalogues" },
    createdby: ["All Users"],
    date: { label: "All Time", value: "" },
  });
  const [queryFilters, setQueryFilters] = useState({
    sort: "date",
    search: "",
    buyer: "",
    status: "",
    createdby: "",
    date: "",
  });

  const loadingState = () => {
    setLoading(false);
  };
  const setStatus = (option) => {
    const tableData = JSON.parse(localStorage.getItem("tableData")) || [];
    setSelectedFilters((state) => {
      return {
        ...state,
        status: option,
      };
    });
    const filteredData =
      option.value === "All Catalogues"
        ? tableData
        : tableData.filter((item) => item.status == option.value);
    setLoading(true);
    if (filteredData.length) createTableData(filteredData);
    else setTableData([]);
    setLoading(false);
  };

  const getCount = (items, type) => {
    const filtered = items.filter((item) => item.type == type) || [];
    return filtered.length ? filtered[0].count : 0;
  };

  // fetch collections
  const fecthCollections = () => {
    const user = localStorage.getItem("user");
    const token = JSON.parse(user).access_token;
    setLoading(true);

    const queryKeys = Object.keys(queryFilters);
    let url = `${process.env.REACT_APP_API_SERVICE}items/collections/getcollectionsbyfilter?token=${token}`;
    for (var index in queryKeys) {
      url = url + `&${queryKeys[index]}=${queryFilters[queryKeys[index]]}`;
    }

    API_KEY.URL.get(url)
      .then((res) => {
        console.log("res----", res?.data?.data);
        setLoading(false);
        const tableData = res?.data?.data?.result;
        if (tableData.length > 0) {
          createTableData(tableData);
          localStorage.setItem("tableData", JSON.stringify(tableData));
        } else {
          setTableData([]);
          localStorage.setItem("tableData", JSON.stringify([]));
        }

        // if (updateFilters) {
        setUpdate(false);
        const filters = res?.data?.data?.filters;
        setFilters((state) => {
          return {
            ...filters,
            ...{
              buyer: updateFilters ? filters.buyer : state.buyer,
            },
          };
        });

        setTotal(res?.data?.data?.total);

        const allCount = filters?.status?.length
          ? filters.status.reduce((item, totalCount) => ({
              count: item.count + totalCount.count,
            })).count
          : 0;

        const statusOptions = {
          "All Catalogues": `All Catalogues (${allCount})`,
          draft: `Draft (${getCount(filters?.status, "draft")})`,
          published: `Active (${getCount(filters?.status, "published")})`,
          inactive: `Inactive (${getCount(filters?.status, "inactive")})`,
        };

        const option = {
          label: statusOptions[selectedFilters.status.value],
          value: selectedFilters.status.value,
        };
        setStatus(option);

        // }
      })
      .catch((err) => {
        console.log("err", err);
        setLoading(false);
      });
  };

  // make api call to get all catalogues
  useEffect(() => {
    fecthCollections();
  }, [queryFilters]);

  /// create table data
  const createTableData = (data) => {
    // console.log("data", data);
    if (data && data?.length > 0) {
      let tableData = data.map((item, index) => {
        return {
          key: index + 1,
          details: {
            name: item?.collection_name,
            products: item.products?.length,
            updatedAt: item?.date_updated
              ? moment(item?.date_updated).format("Do MMM' YY, h:mm a")
              : "",
            updatedBy: item?.updated_by,
            genaratedBy: item?.created_by,
            generatedAt: moment(item?.date_created).format(
              "Do MMM' YY, h:mm a"
            ),
          },
          status: item?.status,
          buyer: { name: item?.buyer_name, email: item?.email_ids },
          controls: {
            id: item.id,
            collection_link: item?.collection_link,
            collection_name: item?.collection_name,
          },
          buyer_activity: item?.buyer_activity,
          linkSecurityData: item?.link_security_data?.id
            ? {
                id: item?.link_security_data?.id,
                security_data: item?.link_security_data?.security_data,
              }
            : {},
        };
      });
      // console.log(object)
      setTableData(tableData);
    }
  };

  // delete catalogue
  const deleteCatalogue = (id) => {
    setActionLoading(true);
    API_KEY.URL.patch(`${API_KEY.path.collections}/${id}`, {
      status: "archived",
    })
      .then((response) => {
        console.log(response?.data?.data);
        fecthCollections();
        setModalType(null);
        setId(null);
        setIsModalVisible(false);
        setActionLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setModalType(null);
        setId(null);
        setIsModalVisible(false);
        setActionLoading(false);
      });
  };

  // deactivate catalogue
  const updateCatalogueStatus = (id, status) => {
    setActionLoading(true);
    API_KEY.URL.patch(`${API_KEY.path.collections}/${id}`, {
      status: status,
    })
      .then((response) => {
        console.log(response?.data?.data);
        fecthCollections();
        setModalType(null);
        setId(null);
        setIsModalVisible(false);
        setActionLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setModalType(null);
        setId(null);
        setIsModalVisible(false);
        setActionLoading(false);
      });
  };

  // activate catalogue
  const activateCatalogue = (id) => {
    API_KEY.URL.patch(`${API_KEY.path.collections}/${id}`, {
      status: "published",
    })
      .then((response) => {
        fecthCollections();
        setModalType(null);
        setId(null);
        setIsModalVisible(false);
        setActionLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setModalType(null);
        setId(null);
        setIsModalVisible(false);
        setActionLoading(false);
      });
  };

  const showModal = (modalType, id, details = {}) => {
    if (modalType && id) {
      setId(id);
      setDetails(details);
      setModalType(modalType);
      setIsModalVisible(true);
    }
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  return (
    <div>
      <Modal
        setActionLoading={setActionLoading}
        details={collectionDetails}
        handleOk={handleOk}
        handleCancel={handleCancel}
        isModalVisible={isModalVisible}
        modalType={modalType}
        deleteCatalogue={deleteCatalogue}
        updateCatalogueStatus={updateCatalogueStatus}
        id={id}
        setId={setId}
        setModalType={setModalType}
        setIsModalVisible={setIsModalVisible}
        actionLoading={actionLoading}
        fetchCollections={fecthCollections}
      />
      <PageTitle title="All Catalogues" total={total} loading={loading} />

      {/* {!loading && (
        <Space>
          <Text>{total} created</Text>
        </Space>
      )} */}

      {!loading && (
        <>
          <Row>
            <Col span={24}>
              <Filters
                loadingState={loadingState}
                setLoading={setLoading}
                createTableData={createTableData}
                setTableData={setTableData}
                filters={filters}
                setFilters={setFilters}
                setQueryFilters={setQueryFilters}
                setSelectedFilters={setSelectedFilters}
                selectedFilters={selectedFilters}
              />
            </Col>
          </Row>
          {/* <Divider style={{ margin: "0.5em" }} /> */}
        </>
      )}

      {!loading && (
        <Space style={{ margin: "15px 0 " }}>
          <Text type="secondary">Showing {tableData.length} catalogues</Text>
        </Space>
      )}

      {loading ? (
        <Skeleton active />
      ) : (
        <Table
          data={tableData}
          showModal={showModal}
          // deleteCatalogue={deleteCatalogue}
          // deactivateCatalogue={deactivateCatalogue}
          activateCatalogue={activateCatalogue}
        />
      )}
    </div>
  );
}
